import { Component } from '@angular/core';
import { NavController, NavParams, Events } from 'ionic-angular';
import { RegistroPage } from '../registro/registro';
import { ViewProvider } from '../../providers/view/view';
import { SemovelProvider } from '../../providers/semovel/semovel';
import { HomePage } from '../home/home';
import { DadosProvider } from '../../providers/dados/dados';
import { CarrinhoProvider } from '../../providers/carrinho/carrinho';
import { SenhaPage } from '../senha/senha';

@Component({
  selector: 'page-login',
  templateUrl: 'login.html',
})
export class LoginPage {
  login = { email:"", senha:""};

  guardarLogin = true;

  constructor(public navCtrl: NavController, public navParams: NavParams, private view:ViewProvider, private server:SemovelProvider,private dadosP:DadosProvider, 
    private events:Events, private carrinho:CarrinhoProvider) {
    let email_tmp = navParams.get("email");
    if(email_tmp){
      this.login.email = email_tmp;
    }

    this.events.subscribe("carregar:cliente", (cliente) => {
      if(cliente){
        this.login.email = cliente.email;

        if(cliente.senha){
          this.guardarLogin = true;
          this.login.senha = cliente.senha;

          this.confirmar();
        }
      }
    });
  }
  
  ionViewDidLoad() {
    if(this.dadosP.cliente){
      this.login.email = this.dadosP.cliente.email;
    }
  }

  validar(){
    let erros:Array<string> = [];

    let c = this.login;
    
    if(!c.email || !c.email.length || c.email.length == 0  ){
      erros.push("O <b>e-mail</b> é obrigatório.");
    }
    
    if(!c.senha || !c.senha.length || c.senha.length == 0  ){
      erros.push("A <b>senha</b> é obrigatória.");
    }

    if(erros.length > 0){
      let msg = "";
      for(var i = 0; i < erros.length; i++){
        msg += erros[i]+"<br>";
      }
      this.view.showMessage(msg);
      return false;
    }

    return true;
  }

  confirmar(){
    if(!this.validar()) return;

    const dados:any = Object.assign({}, this.login);
    dados.firebaseToken = this.dadosP.firebaseToken;

    this.server.postData({method:"cliente/login"}, dados).subscribe(
     (sucesso) => {
        this.server.token_acesso = sucesso.token;
        sucesso.cliente.senha = this.login.senha;

        this.dadosP.salvarCliente(sucesso.cliente, this.guardarLogin) ;
        this.dadosP.salvarEndereco(sucesso.endereco) ;
        this.dadosP.salvarConfiguracao(sucesso.configuracao) ;
        this.navCtrl.setRoot(HomePage);
        //this.carrinho.atualizarPrecos();
     },
     (erro) => {
        this.view.showMessage(erro);
     }
    );
  }

  move_focus(componente){
    componente.setFocus();
  }

  registrar(){
    this.navCtrl.setRoot(RegistroPage);
  }
  
  alterarSenha(){
    this.navCtrl.push(SenhaPage,{email:this.login.email, title:"Recuperar Senha"});
  }

  pular(){
      this.view.showMessage("Para visualizar os nosso produtos não é necessário realizar o cadastro. Porém para adicionar ao carrinho será necessário estar logado.");
      this.navCtrl.setRoot(HomePage);
  }
}



// WEBPACK FOOTER //
// ./src/pages/login/login.ts